import PAYROLL_ANALYTICS, {
    type PayrollAnalyticsEvent,
    type PayrollAnalyticsOutcome,
    type PayrollAnalyticsSource,
} from './analytics';

import { collectiveTracking } from 'modules/common/components/AnalyticsTracking/utils';

interface TrackPayrollActionArgs {
    name: PayrollAnalyticsEvent;
    action: string;
    outcome: PayrollAnalyticsOutcome;
    source: PayrollAnalyticsSource;
    properties?: Record<string, unknown>;
}

/**
 * Fire a payroll Segment event from a non-hook call site (MobX store, plain helper).
 *
 * Prefer `useEventTracking` inside React components — that path stamps member identity.
 * The store still runs for members not yet on `payroll_dashboard_v2`, so it needs a path
 * that does not require a hook. Identity for those events still rides on the analytics user
 * id the tracking script already holds.
 */
export function trackPayrollAction({ name, action, outcome, source, properties = {} }: TrackPayrollActionArgs): void {
    collectiveTracking.track({
        name,
        properties: {
            action,
            outcome,
            source,
            ...properties,
        },
    });
}

export { PAYROLL_ANALYTICS };
